import { TripModuleStatusBackground } from './interfaces';

export const tripStatusBackgroundColor: TripModuleStatusBackground = {
  security: {
    'Порядок 1': {
      1: '#c9daf8ff',
      6: '#ffd966ff',
      8: '#e69138ff',
    },
    'Порядок 2': {
      3: '#c9daf8ff',
      6: '#ffd966ff',
      8: '#e69138ff',
    },
    'Порядок 3': {
      3: '#c9daf8ff',
      6: '#ffd966ff',
      8: '#e69138ff',
    },
  },
  director: {
    'Порядок 1': {
      8: '#e69138ff',
    },
    'Порядок 2': {
      8: '#e69138ff',
    },
    'Порядок 3': {
      8: '#e69138ff',
    },
  },
  ordering: {
    'Порядок 1': {
      2: '#c9daf8ff',
      21: '#c9daf8ff',
      5: '#cdde87',
      51: '#cdde87',
      7: '#e69138ff',
      9: '#c27ba0ff',
    },
    'Порядок 2': {
      1: '#c9daf8ff',
      2: '#c9daf8ff',
      21: '#c9daf8ff',
      5: '#ffd966ff',
      51: '#ffd966ff',
      7: '#e69138ff',
      9: '#c27ba0ff',
    },
    'Порядок 3': {
      1: '#c9daf8ff',
      2: '#c9daf8ff',
      21: '#c9daf8ff',
      5: '#ffd966ff',
      51: '#ffd966ff',
      7: '#e69138ff',
      9: '#c27ba0ff',
    },
  },
};

export const clientDateFormat = 'dd.MM.yyyy, HH:mm';

export const tripStatuses = {
  create: 1,
  parkingInLine: 2,
  waitingOrder: 21,
  waiting: 3,
  downloading: 4,
  parking: 5,
  waitingInvoice: 51,
  waitingDeparture: 6,
  onPause: 7,
  waitingAdmin: 8,
  noOrder: 9,
  unloading: 10,
  parkingNoDocs: 11,
  left: 99,
};

export const tripIntentionStatuses = {
  none: 0,
  loading: 1,
  unloading: 2,
};
